module.exports = __webpack_public_path__ + "img/IN.949db748.png";